import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

export default function PaginationTable(props) {
    const items = props.items || [];
    const emptyMessage = props.emptyMessage ? props.emptyMessage : 'No hay elementos que mostrar';
    if(props.error) {
        return (
            <div className="container">
                <div className="alert alert-danger">
                    {props.error.message}
                </div>
            </div>
        );
    }else if(items.length === 0) {
        return (
            <div className="container">
                <div className="alert alert-warning">
                    {emptyMessage}
                </div>
            </div>
        );
    } else {
        return (
            <div className="container">
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead className="thead-inverse">
                            <props.headerComponent {...props}/>
                        </thead>
                        <tbody>
                            {
                                items.map((item, i) => {
                                    return (
                                        <props.rowComponent key={i} item={item} {...props} />
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>

                <Pages {...props} />
            </div>
        );    
    }
    
}


class Pages extends React.Component {
    constructor(props) {
        super(props);
        this.getPages = this.getPages.bind(this);
        this.shouldJoin = this.shouldJoin.bind(this);
        this.pageNeighbours = this.pageNeighbours.bind(this);
        this.isFirstPage = this.isFirstPage.bind(this);
        this.isLastPage = this.isLastPage.bind(this);
        this.isSinglePage = this.isSinglePage.bind(this);
    }

    getPages() {
        const first = 1;
        const last = this.props.last_page;
        const current = this.props.current_page;
        const segment1 = this.pageNeighbours(first);
        const segment2 = this.pageNeighbours(current);
        const segment3 = this.pageNeighbours(last);
        let pages;
        if(this.shouldJoin(segment1, segment2)) {
            pages = _.union(segment1, segment2);
        } else {
            pages = _.concat(segment1, NaN, segment2);
        }

        if(this.shouldJoin(segment2, segment3)) {
            if( this.shouldJoin(pages, segment3)) {
                pages = _.concat(pages, _.difference(_.union(segment2, segment3), pages));
            }

        } else {
            pages = _.concat(pages, NaN, segment3);
        }

        return pages;
        
    }

    shouldJoin(array1, array2) {
        return _.intersection(array1, array2).length > 0 || (array1[array1.length - 1] + 1) === array2[0] ;
    }

    pageNeighbours(page) {
        return _.range(Math.max(1, page - 2), Math.min(this.props.last_page, page + 2) + 1);
    }

    isFirstPage() {
        return this.props.current_page === 1;
    }

    isLastPage() {
        return this.props.current_page === this.props.last_page;
    }

    isSinglePage() {
        return this.props.last_page === 1;
    }

    changePage(page) {
        return (evt) => {
            evt.preventDefault();
            this.props.pageChange(page);
        }
    }

    render() {
        // const pages = this.getPages();
        if(this.isSinglePage()) return null;
        return (
            <nav className="text-center">
                <ul className="pagination">
                    <li key="p" className={classnames('page-item', {'disabled' : this.isFirstPage()})}>
                        <a href="#" className="page-link" onClick={this.changePage(this.props.current_page - 1)}>
                            &laquo;
                            <span className="sr-only">Anterior</span>
                        </a>
                    </li>
                    {
                        this.getPages().map((page, i) => {
                            if( ! isNaN(page)) {
                                return (
                                    <li key={i} className={classnames('page-item', {'active' : page === this.props.current_page })}>
                                        <a href="#" className="page-link" onClick={this.changePage(page)}>
                                            {page}
                                        </a>
                                    </li>               
                                );
                            } else {
                                return (
                                    <li key={i} className="page-item disabled">
                                        <a className="page-link">
                                            &hellip;
                                        </a>
                                    </li>
                                );
                            }
                        })
                    }
                    <li key="n" className={classnames('page-item', {'disabled' : this.isLastPage()})}>
                        <a href="#" className="page-link" onClick={this.changePage(this.props.current_page + 1)}>
                            &raquo;
                            <span className="sr-only">Siguiente</span>
                        </a>
                    </li>
                </ul>
            </nav>
        );
    }


}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/PaginationTable.jsx
 **/